// store/slices/houseProfileSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchHouseProfileThunk = createAsyncThunk(
  "houseProfile/fetch",
  async (home_id, { rejectWithValue }) => {
    try {
      const res = await api.get(`/api/house-profile/${home_id}`);

      // ✅ supports both:
      // { success:true, data:{...} }  OR  { house:{...} }
      const payload = res.data?.data ?? res.data;

      // if backend uses success flag
      if (res.data?.success === false) {
        return rejectWithValue(res.data?.message || "Failed");
      }

      if (!payload?.house) {
        return rejectWithValue("Invalid profile response (house missing)");
      }

      return payload;
    } catch (e) {
      return rejectWithValue(e?.response?.data?.message || e.message);
    }
  }
);

const houseProfileSlice = createSlice({
  name: "houseProfile",
  initialState: { data: null, loading: false, error: null },
  reducers: {
    clearHouseProfileError: (s) => { s.error = null; },
    clearHouseProfileData: (s) => { s.data = null; },
  },
  extraReducers: (b) => {
    b.addCase(fetchHouseProfileThunk.pending, (s) => {
      s.loading = true;
      s.error = null;
    });
    b.addCase(fetchHouseProfileThunk.fulfilled, (s, a) => {
      s.loading = false;
      s.data = a.payload;
    });
    b.addCase(fetchHouseProfileThunk.rejected, (s, a) => {
      s.loading = false;
      s.error = a.payload || "Failed";
    });
  },
});

export const { clearHouseProfileError, clearHouseProfileData } = houseProfileSlice.actions;
export default houseProfileSlice.reducer;
